/** Replace quotes with real, permissioned reviews before paid ads. Dates help presentation only. Portrait URLs are RandomUser placeholders — swap for real guest photos when you have rights. */

export const testimonialsDisclaimer = 'Testimonials'

export type Testimonial = {
  id: string
  quote: string
  /** Display name as shown publicly (e.g. first + last initial). */
  name: string
  /**
   * Square portrait for the card. Placeholder stock faces (not the named reviewer);
   * replace with permissioned photos before launch.
   */
  photoSrc: string
  /** Typically 5 for featured snippets */
  rating: number
  /** Short relative date label (e.g. “3 weeks ago”) */
  relativeTime: string
  /** Optional ISO date for <time dateTime> when known */
  isoDate?: string
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    quote:
      'The gel lasted three weeks and still looked sharp. Warm space, no rush, and the staff really listens.',
    name: 'Alex M.',
    photoSrc: 'https://randomuser.me/api/portraits/women/44.jpg',
    rating: 5,
    relativeTime: '3 weeks ago',
    isoDate: '2026-04-14',
  },
  {
    id: '2',
    quote:
      'They fixed my nails after a bad break at another place. Shaping is meticulous and the salon is spotless.',
    name: 'Jordan K.',
    photoSrc: 'https://randomuser.me/api/portraits/men/32.jpg',
    rating: 5,
    relativeTime: '1 month ago',
    isoDate: '2026-03-28',
  },
  {
    id: '3',
    quote:
      "Best pedicure I've had in Cerritos. Chairs and tools feel sanitary; booking online was easy.",
    name: 'Sam R.',
    photoSrc: 'https://randomuser.me/api/portraits/women/68.jpg',
    rating: 5,
    relativeTime: '2 months ago',
    isoDate: '2026-03-01',
  },
]
